module.exports = __webpack_public_path__ + "img/logo-headline65x400.1d7b82f7.png";